<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row>
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.partners') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="partnersTable.additionalFilters"
									:default-sort="partnersTable.defaultSort"
									:excel="true"
									:fields="partnersTable.headers"
									:header-selection-key="'partners-headers'"
									:height="partnersTable.height"
									:total-records="partnersTable.total"
									:filter-save-key="'partners-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in partnersTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="partnersTable.selectedHeaders.includes('id')"
											@click="editClick(item.id, false)"
										>
											{{ item.id }}
										</td>
										<td
											v-if="partnersTable.selectedHeaders.includes('name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.name }}</b>
										</td>
										<td
											v-if="partnersTable.selectedHeaders.includes('type')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.type_display }}</b>
										</td>
										<td
											v-if="partnersTable.selectedHeaders.includes('oib')"
											@click="editClick(item.id, false)"
										>
											{{ item.oib }}
										</td>
										<td
											v-if="partnersTable.selectedHeaders.includes('business')"
											@click="editClick(item.id, false)"
										>
											{{ item.business }}
										</td>
										<td
											v-if="partnersTable.selectedHeaders.includes('country_id')"
											@click="editClick(item.id, false)"
										>
											{{ item.country_display }}
										</td>
										<td
											v-if="partnersTable.selectedHeaders.includes('city')"
											@click="editClick(item.id, false)"
										>
											{{ item.city }}
										</td>
										<td
											v-if="partnersTable.selectedHeaders.includes('contact_person')"
											@click="editClick(item.id, false)"
										>
											{{ item.contact_person }}
										</td>
										<td
											v-if="partnersTable.selectedHeaders.includes('phone')"
											@click="editClick(item.id, false)"
										>
											{{ item.phone }}
										</td>
										<td
											v-if="partnersTable.selectedHeaders.includes('email')"
											@click="editClick(item.id, false)"
										>
											{{ item.email }}
										</td>
										<td
											v-if="partnersTable.selectedHeaders.includes('active')"
											@click="editClick(item.id, false)"
										>
											<v-icon v-if="item.active" small>fa-check</v-icon>
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Partners',
	components: { TheTable },
	data: function () {
		return {
			partnersTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.id'), value: 'id', type: 'string', width: '60px', allowFilter: true },
					{ text: this.$t('fields.name'), value: 'name', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.type'),
						value: 'type',
						type: 'dropdown|partner-types',
						allowFilter: true,
					},
					{ text: this.$t('fields.oib'), value: 'oib', type: 'string', allowFilter: true },
					{ text: this.$t('fields.business'), value: 'business', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.country'),
						value: 'country_id',
						type: 'dropdown|countries',
						allowFilter: true,
					},
					{ text: this.$t('fields.city'), value: 'city', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.contactPerson'),
						value: 'contact_person',
						type: 'string',
						allowFilter: true,
					},
					{ text: this.$t('fields.phone'), value: 'phone', type: 'string', allowFilter: true },
					{ text: this.$t('fields.email'), value: 'email', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.active'),
						value: 'active',
						type: 'boolean',
						width: '100px',
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'name',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/partners/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/partners/' + id);
			} else {
				let routeData = this.$router.resolve('/partners/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.partnersTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.partnersTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'partners',
				request,
				(data, success) => {
					if (success) {
						vm.partnersTable.items = data.items;
						vm.partnersTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.partnersTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'partners',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/partners', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.partnersTable.height = window.innerHeight - 215 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.partners'), href: '/#/partners', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
